import {isoFormatToEndDate, isoFormatToStartDate, isoToLocaleFormat} from '../../../../helpers/dateTimeHelper'
import PropTypes from 'prop-types'
import ValueLabel from "../../../../components/ValueLabel";
import {Tag} from "../../../../components/table/Status";

const EventInfo = ({eventInfo}) => {
  return (
    <div className="custom-card flex space-x-6">
      <div className="flex-1 overflow-hidden bg-gray-100 rounded-lg">
        <img src={eventInfo.image} alt="EventImage" className="image-aspect-ratio object-cover"/>
      </div>
      <div className="flex-1">
        <ValueLabel label="Event:" value={eventInfo.name} labelWidth="w-28"/>
        <ValueLabel label="Category:" value={eventInfo.category} labelWidth="w-28"/>
        <ValueLabel label="Type:" value={<Tag label={eventInfo.type}/>}  labelWidth="w-28"/>
        <ValueLabel label="Duration:" value={`${
          isoToLocaleFormat(eventInfo.start_date)} - ${isoToLocaleFormat(eventInfo.end_date)}`} labelWidth="w-28"/>
      </div>
    </div>
  )
}

EventInfo.prototype = {
  eventInfo: PropTypes.object.isRequired,
}

export default EventInfo
